export { default as LabeledTooltip } from './LabeledTooltip.vue';
